import React, { Component } from 'react';
import { connect } from 'react-redux';
import querystring from 'querystring';
import store from 'store2';
import Loading from '../../common/components/Loading';
import getDecodedToken from '../../common/auth/utils/getDecodedToken';
import { pushToast } from '../../redux/actions';
import { connectStripeExpressAccount } from './redux/actions';

class StripeExpressLandingPage extends Component {
  componentDidMount() {
    const { history, location: { search } } = this.props;

    if (!search) {
      history.push('/subscription/ms-admin/profile');
    } else {
      const qs = querystring.parse(search.slice(1));
      if (!qs.state || !qs.code || qs.state !== store.get('stripe_state')) {
        history.push('/subscription/ms-admin/profile');
      } else {
        store.remove('stripe_state');
        this.props.dispatch(connectStripeExpressAccount(getDecodedToken().sub, qs.code));
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.loaded && nextProps.loaded) {
      this.props.dispatch(pushToast({ message: 'Your Stripe Express account has been successfully connected' }));
      this.props.history.push('/subscription/ms-admin/profile');
    }
  }

  render() {
    return <Loading />;
  }
}

const mapStateToProps = state => {
  return {
    loaded: state.subscription.movementSpecialistAdmin.connectStripeExpressAccount.get('loaded'),
  };
};

export default connect(mapStateToProps)(StripeExpressLandingPage);



// WEBPACK FOOTER //
// ./src/subscription/movement-specialist-admin/StripeExpressLandingPage.js